"use client";
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '2rem',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'min(90vw, 600px)',
            background: '#fff',
            border: '1px solid var(--border)',
            borderRadius: '24px',
            boxShadow: '0 20px 50px rgba(0,0,0,0.15)',
            padding: '1.5rem 2rem',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            animation: 'slideUp 0.5s ease-out'
        }}>
            <style jsx>{`
                @keyframes slideUp {
                    from { transform: translate(-50%, 100%); opacity: 0; }
                    to { transform: translate(-50%, 0); opacity: 1; }
                }
            `}</style>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span style={{ fontSize: '1.5rem' }}>🍪</span>
                <h4 style={{ margin: 0, fontWeight: 800, color: '#0f172a' }}>Privacy & Cookie Compliance</h4>
            </div>

            <p style={{ fontSize: '0.9rem', color: '#64748b', margin: 0, lineHeight: 1.6 }}>
                We use cookies and local storage to optimize your technical workflow and maintain your data privacy.
                By continuing to use our industrial utilities, you agree to our
                <Link href="/privacy" style={{ color: 'var(--primary)', fontWeight: 700, margin: '0 4px', textDecoration: 'underline' }}>Privacy Policy</Link>
                and
                <Link href="/cookies" style={{ color: 'var(--primary)', fontWeight: 700, margin: '0 4px', textDecoration: 'underline' }}>Cookie Policy</Link>.
            </p>

            <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem' }}>
                <button
                    onClick={handleAccept}
                    style={{
                        background: 'var(--primary)',
                        color: '#fff',
                        padding: '0.75rem 2rem',
                        borderRadius: '12px',
                        fontWeight: 700,
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                        border: 'none',
                        flex: 1
                    }}
                >
                    I Accept & Understand
                </button>
                <Link
                    href="/privacy-architecture"
                    style={{
                        background: '#f1f5f9',
                        color: '#475569',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '12px',
                        fontWeight: 700,
                        fontSize: '0.9rem',
                        textDecoration: 'none',
                        textAlign: 'center'
                    }}
                >
                    Technical Details
                </Link>
            </div>
        </div>
    );
}
